var map = {
	"./de/impressum.mdx": [
		99329,
		99329
	],
	"./de/index.mdx": [
		47164,
		47164
	],
	"./de/rechtliche-grundlagen.mdx": [
		28503,
		28503
	],
	"./en/imprint.mdx": [
		98047,
		98047
	],
	"./en/index.mdx": [
		13536,
		13536
	],
	"./en/legal-framework.mdx": [
		5904,
		5904
	],
	"./fr/cadre-juridique.mdx": [
		57297,
		57297
	],
	"./fr/impressum.mdx": [
		53356,
		53356
	],
	"./fr/index.mdx": [
		3925,
		3925
	],
	"./it/colophon.mdx": [
		40980,
		40980
	],
	"./it/index.mdx": [
		48362,
		48362
	],
	"./it/quadro-giuridico.mdx": [
		78096,
		78096
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 70227;
module.exports = webpackAsyncContext;